module.exports = __webpack_public_path__ + "126d4effef08e648f5220b132510faf5.pdf";